import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export class ChildMixin extends Vue {
  public currentIndex: any = -1;
  @Prop({ default: false })
  private selected?: boolean;

  private currentSelected: any = 0;

  public mounted() {
    const parent: any = this.$parent;
    parent.updateIndex();
  }

  @Watch("currentSelected", { immediate: false })
  private watchCurrentSelected(val: any) {
    if (val) {
      const parent: any = this.$parent;
      parent.index = this.currentIndex;
    }
  }

  @Watch("selected", { immediate: false })
  private watchSelected(val: any) {
    this.currentSelected = val;
  }

  private onItemClick(hasLink: any) {
    const myThis: any = this;
    if (typeof myThis.disabled === "undefined" || myThis.disabled === false) {
      myThis.currentSelected = true;
      myThis.$parent.currentIndex = this.currentIndex;
      this.$nextTick(() => {
        this.$emit("on-item-click", this.currentIndex);
      });
    }
    if (hasLink === true) {
      this.$router.push({ name: myThis.link });
    }
  }
}
